import colors, { TypeColorNames } from "../../../theme/colors";

export default function PenIcon({
  size,
  onClick,
  style,
  color='label',
}: {
  size?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
  color?: TypeColorNames
}) {
  return (
    <svg
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size || "20"}
      height={size || "20"}
      onClick={onClick}
      style={style}
    >
      <path
        d="M1.66349 11.7463L12.1644 1.24541C12.1918 1.2366 12.224 1.22694 12.2604 1.21709C12.4128 1.1758 12.6318 1.13301 12.8891 1.12946C13.3887 1.12257 14.049 1.2605 14.6901 1.90165C15.3313 2.5428 15.4692 3.2031 15.4623 3.70269C15.4588 3.95996 15.416 4.17898 15.3747 4.33137C15.3648 4.36776 15.3552 4.39991 15.3464 4.42739L4.84547 14.9283L1.22959 15.3622L1.66349 11.7463Z"
        strokeWidth="1.5"
        strokeLinecap="round"
      />

      <svg
        style={{
          cursor: style?.cursor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        width={size || "14"}
        height={size || "14"}
        viewBox="0 0 18 18"
        stroke={colors[color]}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.3464 4.42739L5.84547 14.9283L2.22959 15.3622L2.66349 11.7463L13.1644 1.24541C13.1918 1.2366 13.224 1.22694 13.2604 1.21709C13.4128 1.1758 13.6318 1.13301 13.8891 1.12946C14.3887 1.12257 15.049 1.2605 15.6901 1.90165C16.3313 2.5428 16.4692 3.2031 16.4623 3.70269C16.4588 3.95996 16.416 4.17898 16.3747 4.33137C16.3648 4.36776 16.3552 4.39991 16.3464 4.42739Z"
          stroke={colors[color]}
          strokeLinecap="round"
        />
        <path
          d="M10.7002 2.64871L14.7408 6.68932"
          stroke={colors[color]}
          strokeWidth="1.5"
        />
      </svg>
    </svg>
  );
}
